/*
 * Copyright (C) 2020 Graylog, Inc.
 *
 * This program is free software: you can redistribute it and/or modify
 * it under the terms of the Server Side Public License, version 1,
 * as published by MongoDB, Inc.
 *
 * This program is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE. See the
 * Server Side Public License for more details.
 *
 * You should have received a copy of the Server Side Public License
 * along with this program. If not, see
 * <http://www.mongodb.com/licensing/server-side-public-license>.
 */
import React from 'react';

import Popover from 'components/common/Popover';
import OverflowingComponentsContextProvider from 'views/components/contexts/OverflowingComponentsContextProvider';

type Props = React.PropsWithChildren<{
  isPopoverOpen: boolean;
  onPopoverChange: (isOpen: boolean) => void;
  style: React.CSSProperties;
}>;

const OnClickPopoverWrapper = (
  { children = null, isPopoverOpen, onPopoverChange, style }: Props,
  ref: (node: HTMLElement) => void,
) => (
  <OverflowingComponentsContextProvider>
    <Popover
      opened={isPopoverOpen}
      onChange={onPopoverChange}
      withArrow
      withinPortal={false}
      position="bottom"
      offset={0}>
      <Popover.Target>
        <div ref={ref} style={style} />
      </Popover.Target>
      {children}
    </Popover>
  </OverflowingComponentsContextProvider>
);

export default React.forwardRef(OnClickPopoverWrapper);
